import { Auth, Hub } from "aws-amplify";
import classNames from "classnames";
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth/lib/types";

import { textChooser } from "../../../util/textChooser";
import { useEffect } from "react";
import { saveUserAuthData } from "../../../helpers/utilities";

import { useUser } from "../../../hooks/User";
import { getUserProfile } from "../../../apis/private.api";

import "./buttonSocial.scss";
export interface ButtonSocialProps {
  hideText?: boolean;
  small?: boolean;
  type: "Facebook" | "Google";
}

export const ButtonSocial = ({ small, hideText, type }: ButtonSocialProps) => {
  let config: any;

  const { initUserSession } = useUser()

  switch (type) {
    case "Google":
      config = { lang: "txt7", txt: "google" };
      break;
    case "Facebook":
      config = { lang: "txt8", txt: "facebook" };
      break;
    default:
      config = { lang: "none", txt: "none" };
  }

  const getUser = async () => {
    const response = await Auth.currentAuthenticatedUser()
      .then(userData => userData)
      .catch(() => { });

    return response
  }

  const initSession = (userData: any) => {
    if(!userData) return;

    saveUserAuthData(userData);

    getUserProfile(userData.attributes.email).then((profile) => {
      initUserSession(userData, profile);
    }).catch(() => initUserSession(userData));
  }

  useEffect(() => {
    Hub.listen('auth', ({ payload: { event, data } }) => {
      switch (event) {
        case 'signIn':
        case 'cognitoHostedUI':
          getUser().then(userData => initSession(userData));
          break;
        case 'signOut':
          break;
        case 'signIn_failure':
        case 'cognitoHostedUI_failure':
      }
    });

    getUser().then(userData => initSession(userData));
    // eslint-disable-next-line
  }, []);


  const handleLogin = () => {
    const login = Auth.federatedSignIn({
      provider: CognitoHostedUIIdentityProvider[type]
    })

    return login
  }

  return (
    <button
      className={classNames({
        [type]: true,
        "button-social": true,
        "small": small
      })}
      data-testid={`button-social-${type}`}
      onClick={handleLogin}
    >
      {!hideText && textChooser(config.lang)}
    </button>
  );
};
